import { render, staticRenderFns } from "./HandlerCaseDetailRoute.vue?vue&type=template&id=3c634310"
import script from "./HandlerCaseDetailRoute.vue?vue&type=script&lang=js"
export * from "./HandlerCaseDetailRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports